import styled from "styled-components";
import { Form } from "formik";

const StyledForm = styled(Form)`
  margin: 40px 0 120px;
`;
export default StyledForm;
